import React from 'react';

/** Brand + short pitch above auth tabs / partner title. */
const AuthBrandHeader = () => (
  <header className="login-brand">
    <p className="login-brand-name">MapToBe.com</p>
    <p className="login-brand-pitch">
      Discover events and places worth your time. Save what you love, follow friends, and keep your calendar close.
    </p>
  </header>
);

export default AuthBrandHeader;
